module.exports = __webpack_public_path__ + "stylesheets/global_c0f93b5b24ceae1dd6295c94054e9152.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/global.less
// module id = x7Q4
// module chunks = 151